import { jsxs, jsx } from "react/jsx-runtime";
const IconPropertyTownhouseSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.843 6.576v14.105H1.68V6.576h1.164Zm10.747 0v14.105h-1.165V6.576h1.165ZM6.828 9.464v2.284h2.284V9.464H6.828Zm-.29-.873a.582.582 0 0 0-.583.582v2.866c0 .321.26.582.582.582h2.866c.321 0 .582-.26.582-.582V9.173a.582.582 0 0 0-.582-.582H6.537Zm10.365 3.559v1.613h1.612V12.15h-1.612Zm-.291-.872a.582.582 0 0 0-.582.582v2.194c0 .321.26.582.582.582h2.194c.321 0 .582-.26.582-.582V11.86a.582.582 0 0 0-.582-.582h-2.194ZM6.828 16.18v3.628h2.284V16.18H6.828Zm-.29-.873a.582.582 0 0 0-.583.583v4.209c0 .321.26.582.582.582h2.866a.583.583 0 0 0 .582-.582v-4.21a.582.582 0 0 0-.582-.582H6.537Zm10.365 1.545v2.956h1.612v-2.956h-1.612Zm-.291-.873a.582.582 0 0 0-.582.582V20.1c0 .321.26.582.582.582h2.194a.583.583 0 0 0 .582-.582v-3.54a.582.582 0 0 0-.582-.582h-2.194Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.02 2.917c.372-.235.844-.24 1.221-.014l6.41 3.846a.582.582 0 1 1-.6.998L7.642 3.901 1.565 7.74a.582.582 0 1 1-.622-.984L7.02 2.917Zm10.104 5.002a1.164 1.164 0 0 1 1.177.013l4.745 2.846a.582.582 0 0 1-.6.999L17.703 8.93l-4.406 2.517-.577-1.01 4.405-2.518Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.32 10.606v9.739h-1.163v-9.739h1.164Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20.68c0-.32.26-.581.582-.581h22.836a.582.582 0 1 1 0 1.164H.582A.582.582 0 0 1 0 20.68Z"
        }
      )
    ]
  }
);
export {
  IconPropertyTownhouseSvg
};
